export default __webpack_public_path__ + "static/media/F1_1.21b3a895.png";